import styled from '@emotion/styled';

const Container = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 1;
  gap: ${(p) => p.theme.spacing()}px;
`;

export const DadoLogo = ({ size = 24 }: { size?: number }) => (
  <Container>
    <img
      src={'/images/dado-logo/dado-mark.svg'}
      width={size}
      height={size}
      alt="dado"
    />
  </Container>
);

export const DadoLogoWithName = ({
  size = 24,
  variant
}: {
  size?: number | null;
  variant?: 'default' | 'reverse' | 'black';
}) => (
  <Container>
    <img
      src={
        variant === 'reverse'
          ? '/images/dado-logo/dado-logo-reverse.svg'
          : variant === 'black'
          ? '/images/dado-logo/dado-logo-black.svg'
          : '/images/dado-logo/dado-logo.svg'
      }
      height={size === null ? undefined : size}
      alt="dado"
    />
  </Container>
);
